var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progressionBar"},[_c('v-progress-linear',{attrs:{"type":"number","value":_vm.currentStep}}),_c('StepControl',{attrs:{"currentStep":parseInt(_vm.progress)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }